export const MAINNET_OLD_TOKEN_STAKING_DEPLOYMENT_BLOCK = 9958429
export const MAINNET_OLD_TOKEN_STAKING_DEPLOYMENT_TX_HASH =
  "0x9b3df929d30ccbe6e7e43d447a6c01777bc2462544ea5830c58f82deb369057e"
